import ClientsListPresenter, { ClientsExtendListPresenter } from "./ClientsListPresenter/ClientsListPresenter";


export const ClientList = {
    List : ClientsListPresenter,
    ListClientExtend: ClientsExtendListPresenter
}

export default ClientList;